var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-no-wrap"},[_vm._t("default"),_c('span',{staticClass:"uom-tag"},[_vm._v(" "+_vm._s(_vm.tag)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }